(function () {
  function initModuleImpression(root) {
    if (!root || root.dataset.eofySlideshowModuleImpressionInit === 'true') return;
    root.dataset.eofySlideshowModuleImpressionInit = 'true';

    function isInView() {
      var rect = root.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var visible = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
      return visible >= rect.height * 0.33;
    }

    function pushModuleImpressionGa4() {
      if (root.dataset.eofySlideshowModuleImpression === 'true') return;
      root.dataset.eofySlideshowModuleImpression = 'true';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: 'module_impression',
        event_parameters: {
          module: 'gcm',
        },
      });
    }

    function tryPushModuleImpressionGa4() {
      if (root.dataset.eofySlideshowModuleImpression === 'true') return false;
      if (!isInView()) return false;
      pushModuleImpressionGa4();
      return true;
    }

    if (!('IntersectionObserver' in window)) {
      tryPushModuleImpressionGa4();
      return;
    }

    root._eofySlideshowModuleObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        if (tryPushModuleImpressionGa4()) {
          root._eofySlideshowModuleObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.33 });

    root._eofySlideshowModuleObserver.observe(root);
    tryPushModuleImpressionGa4();
  }

  function pushGa4Event(eventName, eventParameters) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: eventName,
      event_parameters: eventParameters,
    });
  }

  function getSlideContentName(button, slide) {
    var contentName = button.getAttribute('data-content-name');
    if (contentName) return contentName.trim();
    if (!slide) return '';
    var titleEl = slide.querySelector('.eofy-slideshow__slide-title');
    return titleEl ? titleEl.textContent.trim() : '';
  }

  function getSlideButtonName(button) {
    var buttonName = button.getAttribute('data-button-name');
    if (buttonName) return buttonName.trim();
    return button.textContent.trim();
  }

  function pushSelectContentGa4(contentName, buttonName) {
    if (!buttonName) return;
    pushGa4Event('select_content', {
      content_type: 'gcm',
      content_name: contentName || '',
      button_name: buttonName,
    });
  }

  function getHeaderOffset() {
    var header = document.querySelector('.site-header');
    return header ? header.offsetHeight : 0;
  }

  function scrollToRewards() {
    var target = document.querySelector('.eofy-rewards__inner');
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function initButtonTracking(root) {
    if (!root || root.dataset.eofySlideshowButtonInit === 'true') return;
    root.dataset.eofySlideshowButtonInit = 'true';

    root.addEventListener('click', function (event) {
      var button = event.target.closest('.eofy-slideshow__button');
      if (!button || !root.contains(button)) return;

      event.preventDefault();

      var slide = button.closest('.eofy-slideshow__slide');
      pushSelectContentGa4(getSlideContentName(button, slide), getSlideButtonName(button));
      scrollToRewards();
    });
  }

  function destroyButtonTracking(root) {
    if (!root) return;
    delete root.dataset.eofySlideshowButtonInit;
  }

  function destroyModuleImpression(root) {
    if (!root) return;
    if (root._eofySlideshowModuleObserver) {
      root._eofySlideshowModuleObserver.disconnect();
      root._eofySlideshowModuleObserver = null;
    }
    delete root.dataset.eofySlideshowModuleImpressionInit;
    delete root.dataset.eofySlideshowModuleImpression;
  }

  function initEofySlideshow(root) {
    if (!root || root.dataset.eofySlideshowInit === 'true') return;

    var carousel = root.querySelector('.eofy-slideshow__carousel');
    var slides = root.querySelectorAll('.eofy-slideshow__slide');
    if (!carousel || slides.length === 0) return;

    if (typeof Swiper === 'undefined') {
      window.setTimeout(function () {
        initEofySlideshow(root);
      }, 100);
      return;
    }

    root.dataset.eofySlideshowInit = 'true';

    var autoplay = root.dataset.autoplay === 'true';
    var delay = parseInt(root.dataset.autoplayDelay || '6', 10) * 1000;
    var paginationEl = root.querySelector('.eofy-slideshow__pagination');
    var prevBtn = root.querySelector('.eofy-slideshow__nav-btn--prev');
    var nextBtn = root.querySelector('.eofy-slideshow__nav-btn--next');
    var enableLoop = slides.length > 1;

    var config = {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: enableLoop,
      speed: 500,
      watchOverflow: true,
      observer: true,
      observeParents: true,
    };

    if (paginationEl && slides.length > 1) {
      config.pagination = {
        el: paginationEl,
        clickable: true,
        type: 'bullets',
      };
    }

    if (prevBtn && nextBtn && slides.length > 1) {
      config.navigation = {
        prevEl: prevBtn,
        nextEl: nextBtn,
      };
    }

    if (autoplay && slides.length > 1) {
      config.autoplay = {
        delay: delay,
        disableOnInteraction: false,
      };
    }

    root._eofySlideshow = new Swiper(carousel, config);
  }

  function destroyEofySlideshow(root) {
    if (!root) return;
    if (root._eofySlideshow) {
      root._eofySlideshow.destroy(true, true);
      root._eofySlideshow = null;
    }
    delete root.dataset.eofySlideshowInit;
    destroyModuleImpression(root);
    destroyButtonTracking(root);
  }

  function initAll(scope) {
    var context = scope || document;
    context.querySelectorAll('eofy-slideshow').forEach(function (root) {
      initModuleImpression(root);
      initButtonTracking(root);
      initEofySlideshow(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('eofy-slideshow');
    if (!section) return;
    initModuleImpression(section);
    initButtonTracking(section);
    initEofySlideshow(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('eofy-slideshow');
    if (section) destroyEofySlideshow(section);
  });
})();
